<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [hasDefault]="false"
  [isShowModal]="false"
  [columns]="hcolumns"
  (valueChange)="onChange($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="columns && columns.length > 0">
    <editable-grid #grid [columns]="columns" [(dataList)]="dataList" [isAdd]="true" [isDelete]="true" [height]="72"></editable-grid>
  </ng-container>
</dynamic-form>
